module.exports = __webpack_public_path__ + "img/tsuru-icon.de3935ae.svg";